module.exports = __webpack_public_path__ + "dz.svg?28f89f681c28ebecc18251e4674009e6";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/dz.svg
// module id = 795
// module chunks = 27